import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ChangableComponent } from '@models/changable.component';
import { Store } from '@ngrx/store';
import { CLibraryFilterData } from '@store/models';
import { getLibraryRouteData } from '@store/reducers/library.reducer';
import { getMe } from '@store/reducers/profile.reducer';
import { currencies, User } from 'lingo2-models';
import { EContentPanelRoute } from 'lingo2-models/dist/content/enums/content-mode-type';
import { DeviceDetectorService } from 'ngx-device-detector';
import { filter, takeUntil } from 'rxjs/operators';
import { i18nService as TranslateService } from '../../i18n/translate.service';

export interface ILibraryTitle {
  title: string | string[];
  subtitle?: string;
  title_link?: string;
  new_title_link?: string;
  add_link?: string;
  see_all_link?: string;
  all_bottom?: boolean; // ???
}

@Component({
  selector: 'app-library-title',
  templateUrl: './library-title.component.html',
  styleUrls: ['./library-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LibraryTitleComponent extends ChangableComponent implements OnInit {
  private readonly router = inject(Router);
  private store = inject(Store);
  deviceService = inject(DeviceDetectorService);
  translate = inject(TranslateService);

  @Input() public title: Partial<ILibraryTitle>;
  private _libraryFilterData: CLibraryFilterData;
  private _me: User;

  ngOnInit() {
    this.store
      .select(getLibraryRouteData)
      .pipe(filter((v) => !!v))
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (res) => {
          this._libraryFilterData = res;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
        },
      });

    this.store
      .select(getMe)
      .pipe(takeUntil(this.destroyed$))
      .subscribe({
        next: (me) => {
          this._me = me;
          this.detectChanges();
        },
        error: (error) => {
          this.errorNotificationService.captureError(error, 'OTHER-PROBLEM');
        },
      });
  }

  public generatedLink() {
    if (
      this._libraryFilterData.subjectCodes.length &&
      this._libraryFilterData.baseRoute === EContentPanelRoute['main']
    ) {
      return `/${this._libraryFilterData.subjectCodes[0] + this.title.new_title_link}`;
    }
    return this.title.new_title_link;
  }

  public generatedParams() {
    return this._libraryFilterData.currency || this.getMyCurrency();
  }

  public getMyCurrency() {
    if (this._me?.currency_id) {
      return this.translate.directInstant(currencies[this._me?.currency_id]?.title);
    } else {
      return this.translate.directInstant('USD');
    }
  }

  public get titleParts(): string[] {
    return typeof this.title.title === 'string' ? [this.title.title] : this.title.title;
  }

  public followLink(url: string) {
    void this.router.navigateByUrl(url);
  }

  public trackByFn(index) {
    return index;
  }
}
